<template>
    <div>
        <b-modal
            id="reservationPrintModal"
            ref="reservationPrintModal"
            :lazy="true"
            :title="title"
            title-tag="h2"
        >
            <div v-if="message" class="alert alert-warning" role="alert">
                <i class="cus-error"></i>
                {{ message }}
            </div>
            <b-form-group
                :label-for="`printer`"
                v-if="is_email"
                label="Email:"
                label-cols="3"
            >
                <v-select
                    id="recepients"
                    ref="vselect"
                    :options="recepients_options_exclude"
                    v-model="data.recepients"
                    v-validate="'required'"
                    :class="{ 'border-danger': errors.has('recepients') }"
                    :label="'fullname'"
                    placeholder="Staff (required)"
                    name="recepients"
                    multiple
                />
            </b-form-group>
            <b-form-group
                :label-for="`start`"
                label="Start:"
                label-cols="3"
                v-if="!isFixedDate"
            >
                <date-picker
                    :config="datePickerOptions"
                    @dp-change="dateChange($event, 'start')"
                    :value="data.start"
                    v-validate="'required'"
                    :class="{ 'border-danger': errors.has('start') }"
                    class="form-control"
                    name="start"
                ></date-picker>
            </b-form-group>
            <b-form-group
                :label-for="`end`"
                label="End:"
                label-cols="3"
                v-if="!isFixedDate"
            >
                <date-picker
                    :config="datePickerOptions"
                    @dp-change="dateChange($event, 'end')"
                    :value="data.end"
                    v-validate="'required'"
                    :class="{ 'border-danger': errors.has('end') }"
                    class="form-control"
                    name="end"
                ></date-picker>
            </b-form-group>
            <b-form-group
                :label-for="`notes`"
                v-if="is_email"
                label="Notes:"
                label-cols="3"
            >
                <textarea
                    id="notes"
                    v-model="data.notes"
                    class="form-control"
                    placeholder="Notes (optional)"
                    rows="3"
                ></textarea>
            </b-form-group>
            <div slot="modal-footer" class="w-100">
                <b-button
                    @click="$refs.reservationPrintModal.hide()"
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="print" v-else variant="primary">
                        {{ buttonLabel }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import ScheduleHelper from "@/module/schedule/helper";
import vSelect from "vue-select";
export default {
    components: {
        vSelect
    },
    mixins: [ScheduleHelper],
    data() {
        return {
            title: "Print Reservation List",
            staffList: [],
            loading: false,
            data: {
                start: moment(),
                end: moment(),
                recepients: [],
                notes: ""
            },
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            message: "",
            is_email: false,
            buttonLabel: "Submit",
            isFixedDate: false,
            isCheckout: false
        };
    },
    computed: {
        recepients_options_exclude() {
            return _.differenceWith(
                this.staffList,
                this.data.recepients,
                (listA, listB) => listA.id == listB.id
            );
        }
    },
    mounted() {
        this.data.start = moment().tz(this._timeZone);
        this.data.end = moment().tz(this._timeZone);
    },
    methods: {
        open(is_email, start, end, isCheckout = false, isFixedDate = false) {
            this.datePickerOptions.format = this.getDateFormat();
            if (is_email === undefined) {
                throw "is email undefined";
            }
            this.is_email = is_email;
            if (is_email) {
                this.title = "Email Reservation List";
                this.data.recepients = [this.$root.currentActor];
                this.getStaffList();
            } else {
                this.title = "Print Reservation List";
            }

            if (isCheckout) {
                if (is_email) {
                    this.title = "Email Check Out List";
                } else {
                    this.title = "Print Check Out List";
                }
            }

            if (start) {
                this.data.start = start;
            }
            if (end) {
                this.data.end = end;
            }

            this.isCheckout = isCheckout;
            this.isFixedDate = isFixedDate;
            this.buttonLabel = is_email ? "Send" : "Print";
            this.$refs["reservationPrintModal"].show();
        },
        getStaffList() {
            let self = this;
            return this.$http
                .get(process.env.ACTOR_SERVICE + "staff?getAll=1")
                .then(function (response) {
                    self.staffList = response.data.response.resource;
                    return self.staffList;
                });
        },
        dateChange(event, element) {
            this.data[element] = event.date;
        },
        async print() {
            this.loading = true;
            this.message = false;

            try {
                const valid = await this.$validator.validateAll();

                if (!valid) {
                    return false;
                }

                let post = {
                    process_as_email: this.is_email ? 1 : 0,
                    emails:
                        this.data.recepients.length > 0
                            ? _.map(this.data.recepients, i => i.email)
                            : null,
                    end: moment(this.data.end).format(
                        this.datePickerOptions.format
                    ),
                    start: moment(this.data.start).format(
                        this.datePickerOptions.format
                    ),
                    note: this.data.notes
                };

                if (this.is_email && this.isCheckout) {
                    let momentDate = moment(this.data.start);

                    let res = await this.$http.get(
                        `${process.env.BARRAMUNDI}schedule/boarding-dashboard/export-checkout-list`,
                        {
                            params: {
                                date: momentDate.format(this.getDateFormat()),
                                action: "email",
                                recipients: post.emails,
                                note: post.note
                            }
                        }
                    );

                    if (res.data.response.resources.state === 0) {
                        this.$refs.reservationPrintModal.hide();
                        this._message("Email has been sent");
                    } else {
                        this._message("Error: Unable to send email", "danger");
                    }
                } else {
                    const response = await $.post(
                        process.env.APPS +
                            "index.php/schedule/boarding/exportReservation",
                        post
                    );
                    if (response.state == 0) {
                        this.$refs.reservationPrintModal.hide();
                        if (response.path && !this.is_email) {
                            this._redirect(response.path, true, 500);
                        } else {
                            this._message(response.message);
                        }
                    } else {
                        this._message(response.message, "danger");
                    }
                }
            } catch (error) {
                this.loading = false;
                throw error;
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
